<app-skeleton [loading]="loading" height="180px">
    <app-source-detail [baseInfo]="baseInfo"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        [showPercentBar]="false"
        icon="#infigo-snapShot"
    >
    </app-source-detail>
</app-skeleton>
